import c from '@/styles/ArticleDate';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';
import { ArticleDateUpdatedComponent } from './ArticleDate.Updated';

export interface ArticleDateProps extends ComponentProps<'span'> {
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

const ArticleDateComponent: Component<ArticleDateProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const colorsClassName = getPropStyles('colors', colors, 'default');
  const sizeClassName = getPropStyles('size', size, 'default');
  const variantClassName = getPropStyles('variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <span className={componentClassName} {...props}>
      {children}
    </span>
  );
};

export const ArticleDate = Object.assign(ArticleDateComponent, {
  UpdatedDate: ArticleDateUpdatedComponent,
});
